export const getInitialValues = (factoryLineInfo: any, defaultValues: any) => {
  let values = defaultValues;
  if (factoryLineInfo != null) {
    values["globalTitle"] = factoryLineInfo?.globalTitle ?? null;
    values["name"] = factoryLineInfo?.name ?? null;
    values["address"] = factoryLineInfo?.address ?? null;
  }
  return values;
};
